import type { QueryClient } from "@tanstack/react-query";
import { markAlertActionPerformed } from "web_myplann/Api/Portfolio/markAlertActionPerformed";
import {
	AlertBoxActionEnum,
	AlertBoxActionStateEnum,
} from "web_myplann/Infrastructure/Api/Api";
import type {
	AlertBoxActionPerformedRequest,
	BridgeAlertBoxAction,
	BridgeAlertBoxActionState,
} from "web_myplann/Utils/WebViewModel";

const bridgeActionToApi: Record<BridgeAlertBoxAction, AlertBoxActionEnum> = {
	CompareRates: AlertBoxActionEnum.CompareRates,
};

const bridgeStateToApi: Record<
	BridgeAlertBoxActionState,
	AlertBoxActionStateEnum
> = {
	Sent: AlertBoxActionStateEnum.Sent,
};

const isBridgeAlertBoxAction = (
	value: unknown,
): value is BridgeAlertBoxAction =>
	typeof value === "string" && Object.hasOwn(bridgeActionToApi, value);

const isBridgeAlertBoxActionState = (
	value: unknown,
): value is BridgeAlertBoxActionState =>
	typeof value === "string" && Object.hasOwn(bridgeStateToApi, value);

export const handleAlertBoxActionPerformed = (
	payload: unknown,
	queryClient: QueryClient,
): void => {
	if (typeof payload !== "object" || payload === null) {
		return;
	}

	const { contractId, action, state } = payload as Partial<
		AlertBoxActionPerformedRequest["payload"]
	>;

	if (
		typeof contractId !== "number" ||
		!Number.isFinite(contractId) ||
		!isBridgeAlertBoxAction(action) ||
		!isBridgeAlertBoxActionState(state)
	) {
		return;
	}

	markAlertActionPerformed(
		queryClient,
		contractId,
		bridgeActionToApi[action],
		bridgeStateToApi[state],
	);
};
